import { Link } from 'react-router-dom';
import ContactLinks from './ContactLinks';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <span>Resultados gerados por IA — podem conter imprecisões.</span>
      <span className={styles.separator}>|</span>
      <ContactLinks variant="inline" />
      <span className={styles.separator}>|</span>
      <Link to="/ajuda" className={styles.link}>
        Central de ajuda
      </Link>
      <span className={styles.separator}>|</span>
      <Link to="/termos" className={styles.link}>
        Termos de Uso
      </Link>
    </footer>
  );
}
